import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { createPortal } from 'react-dom';
import { forwardRef, useEffect } from 'react';
import '../../../shared/types/colors/index.js';
import { Coverage } from '../../../shared/types/common/index.js';
import { useStyles } from '../styles/index.js';
import { HorizontalAlign, VerticalAlign } from '../types/index.js';

const isWindow = typeof window === 'undefined';
const Overlay = forwardRef(({ children, closeCallback, className, coverage = Coverage.Global, verticalAlign = VerticalAlign.Middle, horizontalAlign = HorizontalAlign.Center, contentIsFullWidth = false, hideScrollbars = false, zIndex = 1, dataTestId, ...props }, ref) => {
    const styles = useStyles({
        zIndex,
        verticalAlign,
        horizontalAlign,
        contentIsFullWidth,
    });
    useEffect(() => {
        const handler = (e) => {
            if (e.key === 'Escape' || e.code === 'Escape') {
                closeCallback?.();
            }
        };
        if (!isWindow) {
            window.addEventListener('keydown', handler);
            if (coverage === Coverage.Global && !isWindow) {
                document.documentElement.classList.add('scroll-frozen');
            }
            return () => {
                window.removeEventListener('keydown', handler);
                if (coverage === Coverage.Global) {
                    document.documentElement.classList.remove('scroll-frozen');
                }
            };
        }
    }, [closeCallback, coverage]);
    const DOM = (jsx("div", { className: clsx(styles.root, styles[coverage], hideScrollbars && styles.hideScrollbars, className), onClick: closeCallback, tabIndex: -1, role: "button", "data-testid": dataTestId || props['data-testid'] || 'overlay', ref: ref, children: jsx("div", { className: styles.table, "data-testid": "table", children: jsx("div", { className: styles.row, "data-testid": "row", children: jsx("div", { className: styles.cell, "data-testid": "cell", children: jsx("div", { className: styles.content, onClick: e => e.stopPropagation(), tabIndex: -1, role: "button", "data-testid": "content", children: children }) }) }) }) }));
    const portal = !isWindow ? createPortal(DOM, document.body) : null;
    return coverage === Coverage.Local ? DOM : portal;
});
Overlay.displayName = 'Overlay';

export { Overlay };
